// Pure helpers for the Home page HTML→JSX renderer (jsxer.js). Extracted so
// they can be unit tested without a JSX/React harness.

/**
 * Slugify a string for use as an anchor id / hash link target.
 * Accented characters are transliterated, everything outside [a-z0-9- ] is
 * stripped, spaces become dashes, and the result is lowercased.
 */
export function slugify (str = '') {
  return str
    .trim()
    .replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g, 'a')
    .replace(/[çÇ]/g, 'c')
    .replace(/[ðÐ]/g, 'd')
    .replace(/[ÈÉÊËéèêë]/g, 'e')
    .replace(/[ÏïÎîÍíÌì]/g, 'i')
    .replace(/[Ññ]/g, 'n')
    .replace(/[øØœŒÕõÔôÓóÒò]/g, 'o')
    .replace(/[ÜüÛûÚúÙù]/g, 'u')
    .replace(/[ŸÿÝý]/g, 'y')
    .replace(/[^a-z0-9- ]/gi, '')
    .replace(/ /gi, '-')
    .toLowerCase()
}

/**
 * Resolve the anchor props for a Link element.
 *
 * `hash` takes precedence and produces `href="#<slugified hash>"`; otherwise
 * `href` is `url || to`, with `target="_blank"` added for external links.
 *
 * @throws when both `url` and `hash` are provided
 */
export function getLinkProps ({ url, to, hash } = {}) {
  if (url && hash) throw new Error('Cannot have both hash and url for a link. hash:', hash, 'url:', url)

  let props = {}

  if (hash) {
    props.href = `#${slugify(hash)}`
  } else {
    props.href = url || to
    if (props.href.startsWith('http')) {
      props.target = '_blank'
    }
  }

  return props
}
